import { render } from "./ListDocuments.vue?vue&type=template&id=0f402296&scoped=true"
import script from "./ListDocuments.vue?vue&type=script&lang=js"
export * from "./ListDocuments.vue?vue&type=script&lang=js"

import "./ListDocuments.vue?vue&type=style&index=0&id=0f402296&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f402296"]])

export default __exports__